import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import SelectOrderTypeModalContent from './SelectOrderTypeModalContent';
export const SelectOrderTypeModal = {
    show: (symbol, hasRecurringBuy, onSelectOrderType) => {
        Modal.show(<SelectOrderTypeModalContent symbol={symbol} closeModal={Modal.hide} hasRecurringBuy={hasRecurringBuy} onSelectOrderType={onSelectOrderType}/>, {
            title: 'Order type',
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
